import * as constants from '../constants';

const INITIAL_EXPORT_STATE = {
    exporting: false,
    data: null,
};

const INITIAL_STATE = {
    items: {},
    dashboards: {},
    error: null,
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case constants.AUTH_LOGOUT:
        case constants.AUTH_LOGIN_SUCCESS:
            return INITIAL_STATE;

        case constants.SURVEY_EXPORT_REQUESTED: {
            const newItems = Object.assign({}, state.items);
            newItems[action.payload.id] = {exporting: true, data: null};
            return Object.assign({}, state, {items: newItems, error: null});
        }
        case constants.SURVEY_EXPORT_SUCCESS: {
            const newItems = Object.assign({}, state.items);
            newItems[action.payload.id] = {exporting: false, data: action.payload.data};
            return Object.assign({}, state, {items: newItems, error: null});
        }
        case constants.SURVEY_EXPORT_FAILURE: {
            const newItems = Object.assign({}, state.items);
            newItems[action.payload.id] = {exporting: false, data: null};
            return Object.assign({}, state, {items: newItems, error: action.payload.error});
        }
        case constants.SURVEY_EXPORT_COMPLETE: {
            const newItems = Object.assign({}, state.items);
            newItems[action.payload.id] = INITIAL_EXPORT_STATE;
            return Object.assign({}, state, {items: newItems, error: null});
        }
        case constants.DASHBOARD_EXPORT_REQUESTED: {
            const newDashboards = Object.assign({}, state.dashboards);
            newDashboards[action.payload.id] = {exporting: true, data: null};
            return Object.assign({}, state, {dashboards: newDashboards, error: null});
        }
        case constants.DASHBOARD_EXPORT_SUCCESS: {
            const newDashboards = Object.assign({}, state.dashboards);
            newDashboards[action.payload.id] = {exporting: false, data: action.payload.data};
            return Object.assign({}, state, {dashboards: newDashboards, error: null});
        }
        case constants.DASHBOARD_EXPORT_FAILURE: {
            const newDashboards = Object.assign({}, state.dashboards);
            newDashboards[action.payload.id] = {exporting: false, data: null};
            return Object.assign({}, state, {dashboards: newDashboards, error: action.payload.error});
        }
        case constants.DASHBOARD_EXPORT_COMPLETE: {
            const newDashboards = Object.assign({}, state.dashboards);
            newDashboards[action.payload.id] = INITIAL_EXPORT_STATE;
            return Object.assign({}, state, {dashboards: newDashboards, error: null});
        }
    }
    return state;
}
